export enum WorkFlowOutcome {
  Approved = 1,
  Rejected = 2,
}
